export const mappingFormPageStateGroup = state => {
  return [
    state.authentication.token,
    state.mapping.mappingList,
    state.utils.modalType,
    state.mapping.mappingForm,
  ];
};
